import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import usePrequalUpdate from '../../resources/prequal/usePrequalUpdate';

import { INVALID_VERIFICATION_CODE } from '../../constants';

const errorSchema = {
  [INVALID_VERIFICATION_CODE]: {
    verificationCode: ['Invalid code. Please try again.'],
  },
};

const useForm = () => useSWRMutationForm({
  useMutation: usePrequalUpdate,
  errorSchema,
  useUnhandledError: useErrorToSnackbar,
});

export default useForm;
